import { inject, Injectable, signal } from '@angular/core';
import { WebsiteData } from '../../shared/models/website-overview.model';
import { Observable, filter, of, tap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { GroupData } from '../../shared/models/group-overview.model';

@Injectable({
  providedIn: 'root',
})
export class WebsiteStoreService {
  private readonly http = inject(HttpClient);

  readonly websiteData = signal<WebsiteData | null>(null);

  readonly groupData = signal<GroupData | null>(null);

  loadWebsiteData(
    websiteId: number,
    bandwidthFromTimestamp: number,
    bandwidthToTimestamp: number,
  ): Observable<WebsiteData> {
    const storedData = this.websiteData();

    // Return cached data if the ID matches
    if (storedData !== null && storedData.website.id === websiteId) {
      return of(storedData);
    }

    // Otherwise, make an HTTP request
    return this.http
      .get<WebsiteData>(
        `/backend-for-frontend/website/${websiteId}?bandwidthFrom=${bandwidthFromTimestamp}&bandwidthTo=${bandwidthToTimestamp}`,
      )
      .pipe(
        filter((data) => data.website !== null),
        tap((data) => this.websiteData.set(data)),
      );
  }

  loadGroupData(
    groupId: number,
    bandwidthFromTimestamp: number,
    bandwidthToTimestamp: number,
    cpuFromTimestamp: number,
    cpuToTimestamp: number,
  ): Observable<GroupData> {
    const storedData = this.groupData();

    // Return cached data if the ID matches
    if (storedData !== null && storedData.websiteGroup?.id === groupId) {
      return of(storedData);
    }

    // Otherwise, make an HTTP request
    return this.http
      .get<GroupData>(
        `/backend-for-frontend/group/${groupId}?bandwidthFrom=${bandwidthFromTimestamp}&bandwidthTo=${bandwidthToTimestamp}&cpuFrom=${cpuFromTimestamp}&cpuTo=${cpuToTimestamp}`,
      )
      .pipe(
        filter((data) => data.websiteGroup !== null),
        tap((data) => this.groupData.set(data)),
      );
  }
}
